export { default } from "./ReviewsImage";
